<div class="wrapper">
  <div class="card">
    <img src="assets/images/auth.png" height="150px" width="150px" alt="Token expirado" />
    <h1 class="title">Token expirado</h1>
    <p class="message">
      Por favor, abra o aplicativo e gere um novo para continuar.
    </p>
  </div>
</div>
